module.exports = __webpack_public_path__ + "static/media/11.2e2e0d79.png";